import Conclave from '../components/conclave';

export default function Ortherconclave() {
  return (
    <Conclave
      geturl="https://cpccbe.org/api/ortherconclave/allmodals"
      createmodel1url="https://cpccbe.org/api/ortherconclave/modal1"
      createmodel2url="https://cpccbe.org/api/ortherconclave/modal2"
      updateurl="https://cpccbe.org/api/ortherconclave/modal"
      deleteurl="https://cpccbe.org/api/ortherconclave/modal"
      head="Other Conclave"
    />
  );
}
